export type ObjetoEditable = Record<string, unknown>;

export type SeccionPagina = ObjetoEditable & {
  attr?: {
    style?: Record<string, string>;
  };
};

export type SeccionesPagina = Record<string, SeccionPagina>;

export type PaginaPrincipalResponse = {
  principal?: ObjetoEditable;
  medios_pago?: unknown[];
  secciones?: SeccionesPagina;
};

function esObjetoEditable(valor: unknown): valor is ObjetoEditable {
  return Boolean(valor) && typeof valor === 'object' && !Array.isArray(valor);
}

export function construirEstiloSeccion(
  secciones: SeccionesPagina | undefined,
  seccion: string,
  baseUrl: string,
): string {
  const estilo = secciones?.[seccion]?.attr?.style;

  if (!estilo || typeof estilo !== 'object') {
    return '';
  }

  return Object.keys(estilo)
    .filter((key) => estilo[key] !== '')
    .map((key) => {
      if (key === 'background-image') {
        return `${key}: url('${baseUrl}img/empresas/web/secciones/${estilo[key]}'); `;
      }

      return `${key}:${estilo[key]} !important; `;
    })
    .join('');
}

export function normalizarRespuestaPaginaPrincipal(
  payload: unknown,
): Required<Pick<PaginaPrincipalResponse, 'principal' | 'medios_pago' | 'secciones'>> {
  const respuesta = esObjetoEditable(payload) ? (payload as PaginaPrincipalResponse) : {};
  const principal: ObjetoEditable =
    esObjetoEditable(respuesta.principal) ? { ...respuesta.principal } : {};

  const empresa = principal.empresa as ObjetoEditable | undefined;
  if (!empresa) {
    principal.empresa = { logo: '' };
  } else if (!empresa.logo) {
    empresa.logo = '';
  }

  if (!principal.datos_contacto) {
    principal.datos_contacto = {};
  }

  if (!principal.redes_sociales) {
    principal.redes_sociales = {};
  }

  if (!principal.servicios) {
    principal.servicios = {};
  }

  if (!principal.vehiculos) {
    principal.vehiculos = {
      mostrar_seccion: true,
      titulo: 'Nuestros vehículos',
      subtitulo: '',
      vehiculo: [],
    };
  }

  if (!principal.presentacion) {
    principal.presentacion = {};
  }

  return {
    principal,
    medios_pago: Array.isArray(respuesta.medios_pago) ? respuesta.medios_pago : [],
    secciones: esObjetoEditable(respuesta.secciones) ? (respuesta.secciones as SeccionesPagina) : {},
  };
}